import { State } from '../reducers/types'
import { MCOnboardingCounts } from 'src/interfaces/mcOnboarding'

export const getMCOnboardingCounts = (state: State): MCOnboardingCounts | null =>
  state.mcOnboarding.mcOnboardingCounts
